<div class="p-card-title">
  <div class="aumentar-fuente">
    <h1 class="mt-0 mb-0">
      <span class="font-bold text-red-500">{{ tituloResaltadoEnRojo }}</span>
      {{ restoDelTitulo }}
    </h1>
  </div>
  <div class="flex justify-content-end gap-5 mb-2">
    <div *ngIf="verBotonNuevo">
      <button
        id="btnAgregar"
        pButton
        pRipple
        type="button"
        class="p-button-success p-button-raised"
        (click)="onBotonNuevoClick()"
      >
        {{ textoBotonNuevo }}
      </button>
    </div>
    <div>
      <button
        *ngIf="verBotonFiltros"
        pButton
        pRipple
        type="button"
        (click)="ocultarFiltros()"
        [icon]="collapsed ? 'pi pi-angle-right' : 'pi pi-angle-down'"
        class="p-button-rounded p-button-text p-button-lg"
        [pTooltip]="collapsed ? 'Ocultar Filtros' : 'Mostrar Filtros'"
        tooltipPosition="bottom"
      ></button>
    </div>
  </div>
  <div class="linea-divisora"></div>
</div>
